var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"nav navbar-nav nav-mobile-menu"},[_c('h5',{attrs:{"id":"fullname"}},[_c('span',{staticClass:"ti-user"}),_vm._v(_vm._s(_vm.fullname))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }